

import "./_primary.scss";

$(function () {
    //ADD TABLE-RESPONSIVE BOOTSTRAP CLASS TO TABLES
    $('.site-content__primary table').addClass('table-responsive');
}); 